import { cta } from "../landing-copy";
import { navigate } from "../router";
import { CTA_DELAY } from "./Subtitle";

export default function SeeHowItWorks() {
  return (
    <a
      className="cta cta-enter"
      href="/how-it-works"
      style={{ animationDelay: CTA_DELAY.toFixed(3) + "s" }}
      onClick={(e: any) => {
        if (
          e.defaultPrevented ||
          e.button !== 0 ||
          e.metaKey ||
          e.ctrlKey ||
          e.shiftKey ||
          e.altKey
        ) {
          return;
        }
        e.preventDefault();
        navigate("/how-it-works");
      }}
    >
      {cta}
      <span className="cta-arrow" aria-hidden="true">
        →
      </span>
    </a>
  );
}
